const IconSupport = () => {
  return (
    <svg
      xmlns='http://www.w3.org/2000/svg'
      width='20'
      height='20'
      viewBox='0 0 20 20'
      fill='none'
    >
      <circle cx='10' cy='10' r='9' stroke='white' strokeWidth='1.6' />
      <path
        d='M10 5.5V10.75'
        stroke='white'
        strokeWidth='1.6'
        strokeLinecap='round'
      />
      <circle cx='10' cy='14' r='1' fill='white' />
    </svg>
  )
}

export default IconSupport
